import {
  Action,
  Alert,
  Checkbox,
  CorsoLogo,
  Modal,
  SpinnerIcon,
} from 'corso-admin-ui';
import { WidgetConfig } from 'corso-types';
import { useState } from 'react';

function ModalPreview({
  show,
  onClose,
  modal,
}: {
  show: boolean;
  modal: WidgetConfig['modal'];
  onClose: () => void;
}) {
  return (
    <Modal show={show} onClose={onClose} size="lg" title="">
      <div>
        {modal.imageUrl.length && (
          <img src={modal.imageUrl} alt="widget banner" />
        )}
        <div className="flex flex-col gap-2 p-4">
          <p className="text-center text-lg font-medium">{modal.title}</p>
          <p className="text-sm">{modal.description}</p>
          {modal.benefits.map(({ title, description: modalDescription }) => (
            <div key={title} className="flex flex-col gap-1.5 p-2">
              <p className="font-md font-medium">{title}</p>
              <p className="text-xs">{modalDescription}</p>
            </div>
          ))}
          <div className="flex justify-between gap-2 pt-2 text-xs underline">
            <p>Privacy Policy </p>|<p>CA Privacy Notice</p>|<p>Terms</p>|
            <p>Report Shipping Issue</p>
            <CorsoLogo size="base" />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default function CheckoutWidgetPreview({
  label,
  description,
  modal,
  showCheckbox = false,
}: {
  label: string;
  description?: string | null;
  modal: WidgetConfig['modal'];
  showCheckbox?: boolean;
}) {
  const [showWidgetModal, setShowWidgetModal] = useState(false);
  const [checked, setChecked] = useState(true);
  const [isLoadingSimulation, setIsLoadingSimulation] = useState(false);

  return (
    <>
      <Alert
        variant="info"
        heading="This is a preview of the checkout widget. The actual appearance may vary based on your theme and customizations."
      />

      <div>
        <div className="flex max-w-2xl flex-col gap-1 rounded-lg border border-neutral-200 bg-white p-4 shadow-sm">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              {showCheckbox &&
                (isLoadingSimulation ? (
                  <SpinnerIcon className="text-corso-blue-800" />
                ) : (
                  <Checkbox
                    id="shipping-protection-preview"
                    onChange={(e) => {
                      setIsLoadingSimulation(true);
                      setTimeout(() => {
                        setChecked(e.target.checked);
                        setIsLoadingSimulation(false);
                      }, 500);
                    }}
                    checked={checked}
                  />
                ))}
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-neutral-900">
                  {label}
                </span>
                <Action
                  variant="ghost"
                  icon="info"
                  accessibilityLabel="Learn More"
                  onClick={() => setShowWidgetModal(!showWidgetModal)}
                  className="text-corso-blue-800 hover:text-corso-blue-700"
                />
              </div>
            </div>
            {showCheckbox && (
              <span className="text-sm font-medium text-neutral-900">
                $1.29
              </span>
            )}
          </div>
          {description && (
            <div className="flex items-start gap-3">
              {showCheckbox && <div className="w-4" />}{' '}
              <p className="text-xs leading-relaxed text-neutral-600">
                {description}
              </p>
            </div>
          )}
        </div>

        <ModalPreview
          show={showWidgetModal}
          onClose={() => setShowWidgetModal(false)}
          modal={modal}
        />
      </div>
    </>
  );
}
